export const extractFullNameParts = (fullName: string): { firstName: string; lastName: string } => {
  if (!fullName || !fullName.trim()) {
    return {
      firstName: "first name",
      lastName: "last name"
    };
  }

  const parts = fullName.trim().split(/\s+/);

  if (parts.length === 1) {
    return {
      firstName: parts[0],
      lastName: "last name"
    };
  }

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" ")
  };
};
